import AboutModal from './AboutModal.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import DataSourceConfiguration from './DataSourceConfiguration.json';
import DatePicker from './DatePicker.json';
import ErrorBoundary from './ErrorBoundary.json';
import Header from './Header.json';
import HotkeysValidators from './HotkeysValidators.json';
import MeasurementTable from './MeasurementTable.json';
import Modes from './Modes.json';
import SegmentationTable from './SegmentationTable.json';
import SidePanel from './SidePanel.json';
import StudyBrowser from './StudyBrowser.json';
import StudyItem from './StudyItem.json';
import StudyList from './StudyList.json';
import TooltipClipboard from './TooltipClipboard.json';
import ThumbnailTracked from './ThumbnailTracked.json';
import TrackedCornerstoneViewport from './TrackedCornerstoneViewport.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';
import Messages from './Messages.json';

export default {
  'en-US': {
    AboutModal,
    Buttons,
    CineDialog,
    Common,
    DataSourceConfiguration,
    DatePicker,
    ErrorBoundary,
    Header,
    HotkeysValidators,
    MeasurementTable,
    Modes,
    SegmentationTable,
    SidePanel,
    StudyBrowser,
    StudyItem,
    StudyList,
    TooltipClipboard,
    ThumbnailTracked,
    TrackedCornerstoneViewport,
    UserPreferencesModal,
    ViewportDownloadForm,
    Messages,
  },
};
